import { ajax } from '../../../services/helper'
class ApiService {

    getNewJoineeData = (from,to,city_id,kitchen_id,status) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/newJoinees/list?from="+from+"&to="+to+"&city_id="+city_id+"&kitchen_id="+kitchen_id+"&status="+status
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    addNewJoinee = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employeeMovements/add"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


     getKitchensListData = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/kitchens/getCombo?type=city_scope"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

 editNewJoinee = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/newJoinees/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    

    
}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/New Joinee/services/apiservices.js